<template>
  <div class="game-home">
    <div class="dashboard-grid">
      <HomeEmpireSummary class="home-widget widget-empire" />
      <div class="widget-left-stack">
        <HomeQuestStatus class="home-widget" />
        <HomeWorldIntel class="home-widget" />
      </div>
      <HomeHeroDetails class="home-widget widget-hero" />
    </div>
  </div>
</template>

<script setup>
import { onMounted } from "vue";
import { useGameStore } from "../store/game";
import HomeEmpireSummary from "../components/HomeEmpireSummary.vue";
import HomeQuestStatus from "../components/HomeQuestStatus.vue";
import HomeHeroDetails from "../components/HomeHeroDetails.vue";
import HomeWorldIntel from "../components/HomeWorldIntel.vue";

const gameStore = useGameStore();

onMounted(async () => {
  await gameStore.fetchPlayerAssets();
  const tasks = [
    gameStore.fetchPlayerResources(),
    gameStore.fetchAvailableQuests(),
    gameStore.fetchActiveQuests(),
    gameStore.fetchPlayerCards(),
    gameStore.fetchWorldIntel(),
  ];
  if (gameStore.activeHero?.id) {
    if (!gameStore.heroProgression) {
      tasks.push(gameStore.fetchHeroProgression());
    }
    tasks.push(gameStore.fetchHeroSockets(gameStore.activeHero.id));
  }
  await Promise.all(tasks);
});
</script>

<style scoped>
.game-home {
  flex: 1;
  min-height: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem 1rem 2.5rem;
  box-sizing: border-box;
}

.dashboard-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 1fr 1fr;
  gap: 1rem;
  height: 100%;
  max-height: 100%;
  aspect-ratio: 1 / 1;
  max-width: 100%;
  margin: 0 auto;
}

.home-widget {
  min-width: 0;
  min-height: 0;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  background: rgba(10, 15, 30, 0.95);
  border: 1px solid #00f0ff;
  border-radius: 8px;
  box-shadow: 0 0 10px rgba(0, 240, 255, 0.1);
}

.widget-empire {
  grid-column: 1;
  grid-row: 1;
}

.widget-left-stack {
  grid-column: 1;
  grid-row: 2;
  min-width: 0;
  min-height: 0;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  overflow: hidden;
}

.widget-left-stack .home-widget {
  flex: 1;
}

.widget-hero {
  grid-column: 2;
  grid-row: 1 / span 2;
}

@media (max-width: 768px) {
  .game-home {
    align-items: stretch;
    justify-content: flex-start;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    padding-bottom: 80px;
  }

  .dashboard-grid {
    grid-template-columns: 1fr;
    grid-template-rows: none;
    grid-auto-rows: auto;
    height: auto;
    max-height: none;
    aspect-ratio: auto;
    width: 100%;
  }

  .home-widget {
    overflow: visible;
    height: auto;
  }

  .widget-empire {
    grid-column: 1;
    grid-row: auto;
    order: 1;
  }

  .widget-hero {
    grid-column: 1;
    grid-row: auto;
    order: 2;
  }

  .widget-left-stack {
    grid-column: 1;
    grid-row: auto;
    order: 3;
    overflow: visible;
    height: auto;
  }

  .widget-left-stack .home-widget {
    flex: 0 0 auto;
  }
}
</style>
